@if (label(); as text) {
  <p class="px-3 pt-1 pb-1.5 text-xs tracking-tight text-zinc-400">
    {{ text }}
  </p>
}
<ng-content></ng-content>
